import {
    // FILE_UPLOAD,
    CREATE_VISITALERT,
    RETRIEVE_VISITALERT,
    RETRIEVESINGLE_VISITALERT,
    UPDATE_VISITALERT,
    DELETE_VISITALERT,
} from "./type";
import VisitAlert from "../service/VisitAlert";
export const create = (data) => async (dispatch) => {
    try {
        const res = await VisitAlert.create(data);
        dispatch({
            type: CREATE_VISITALERT,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await VisitAlert.fetchList(data);
        dispatch({
            type: RETRIEVE_VISITALERT,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await VisitAlert.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_VISITALERT,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await VisitAlert.update(data);
        dispatch({
            type: UPDATE_VISITALERT,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await VisitAlert.changeStatus(data);
//         dispatch({
//             type: UPDATE_VISITALERT,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await VisitAlert.trash(data);
        dispatch({
            type: DELETE_VISITALERT,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};